export default __webpack_public_path__ + "static/media/A_lopetus6.49a0ccfa.mp3";